/**
 * rds模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const rds = {
  //数据库列表分页
  pageRDS(params) {
    return $http.post(`${global.API_URL}/sme/rds/page`,params);
  },
  //数据库列表分页
  pageRDSByApplicationId(params) {
    return $http.post(`${global.API_URL}/sme/rds/queryDatabasesByApplicationId`,params);
  },
  //数据库删除
  deleteRDS(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/rds/delete`,param);
  },
  // 根据AccountId查询数据库列表
  queryRDSByAccountId(params) {
    return $http.post(`${global.API_URL}/sme/rds/queryRDSByAccountId`,params);
  },
  // 通过数据库id查询RDS实例
  queryDatabasesById(params) {
    return $http.post(`${global.API_URL}/sme/rds/queryDatabasesById`,params);
  },
  //查询数据库引擎
  queryDatabaseEngines(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/rds/queryDatabaseEngines`,param);
  },
  //根据账户名称查询数据库列表
  queryDatabaseByAccountId(id,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/rds/queryDatabaseByAccountId`,param);
  },
}

export default rds;



// WEBPACK FOOTER //
// ./src/api/rds.js